import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function LogoIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="125.000000pt"
        height="125.000000pt"
        viewBox="0 0 125.000000 125.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,125.000000) scale(0.100000,-0.100000)"
          fill="#FFFFFF"
          stroke="none"
        >
          <path
            d="M495 1235 c-212 -44 -401 -216 -466 -427 -108 -347 119 -726 474
-793 99 -19 145 -19 244 0 241 45 443 247 488 488 19 99 19 145 0 244 -41 218
-211 407 -428 475 -82 25 -223 31 -312 13z m240 -120 c33 -9 87 -29 121 -45
62 -30 165 -123 196 -178 l18 -30 -145 -146 c-136 -138 -147 -146 -183 -146
-53 0 -95 34 -182 148 -73 94 -143 152 -185 152 -31 0 -109 -44 -183 -102 -35
-27 -66 -48 -68 -45 -7 6 34 117 60 161 30 52 127 145 186 178 110 63 248 83
365 53z m-174 -442 c22 -20 71 -82 109 -137 66 -97 108 -136 146 -136 41 0
113 49 211 143 l103 100 0 -34 c0 -19 -7 -63 -15 -98 -56 -236 -287 -406 -525
-388 -88 7 -174 35 -240 77 -68 43 -156 140 -185 202 l-25 53 108 108 c116
116 164 147 229 147 35 0 50 -7 84 -37z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
